import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import Button from '../../Button/Button';
import errorIcon from '../../../assets/images/errorIcon.svg';
import { CustomLawValidationCode } from '../../../models/CustomLawValidationCode';
import Modal from '../Modal';
import styled from './ValidationErrorModal.module.css';

interface Props {
    code: CustomLawValidationCode;
    onClose: () => void;
}

const codeTranslationMap: Record<CustomLawValidationCode, string> = {
    [CustomLawValidationCode.FILE_MAX_SIZE]: 'errorValidationModalFileMaxSize',
    [CustomLawValidationCode.TEXT_MAX_SIZE]: 'errorValidationModalTextMaxSize',
};

const ValidationErrorModal: FC<Props> = ({ code, onClose }) => {
    const { t } = useTranslation();
    const translationKey = codeTranslationMap[code];

    return (
        <Modal title={t('errorValidationModalTitle')} className={styled.Modal}>
            <img src={errorIcon} alt="error" className={styled.ErrorIcon} />
            <p>{t(translationKey ? t(translationKey) : code)}</p>
            <div className={styled.Buttons}>
                <Button variant="Primary" onClick={onClose}>
                    OK
                </Button>
            </div>
        </Modal>
    );
};

export default ValidationErrorModal;
